













































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import UpdateExpTableModal from './UpdateExpTableModal.vue';

@Component({
    methods: {
        ...mapActions('bh-exp-tables', { saveNewExpTable: 'create' })
    },
    components: {
        UpdateExpTableModal
    }
})
export default class ExpTableManger extends Vue {
    dialogAddTemplate = false;
    dialogLoading = false;
    form = {
        tier: null,
        level: null,
        exp_required: null,
        time_estimated_sec: null
    };
    headers = [
        {
            text: 'Level',
            align: 'start',
            sortable: false,
            value: 'level',
        },
        {
            text: 'Tier',
            align: 'start',
            sortable: false,
            value: 'tier',
        },
        {
            text: 'Influencer Points',
            align: 'start',
            sortable: false,
            value: 'exp_required',
        },
        {
            text: 'Time Estimate (sec)',
            align: 'start',
            sortable: false,
            value: 'time_estimated_sec',
        },
        {
            text: 'Actions',
            align: 'end',
            value: 'data-table-expand'
        }
    ];
    query = { /*id: { $nin: [this.user.id] }*/ };
    pagination = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
    };
    
    saveNewExpTable: any;

    public get fetchQuery() {
        return Object.assign({}, {
            ...this.query,
            // ...this.extendedQuery,
            $populate: true
        }, {
            // ...this.searchQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        });
    }

    public get dataQuery() {
        return {
            ...this.query,
            // ...this.extendedQuery,
            // ...this.searchDataQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        };
    }

    public get sortingQuery() {
        if(this.pagination.sortBy.length !== 0) {
            const $sort: any = {};
            this.pagination.sortBy.map((item, index) => {
                switch(item) {
                    default:
                        $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                }
                
            });
            return { $sort };
        }
        return null;
    }

    public async addExpTemplate() {
        try {
            this.dialogLoading = true;
            await this.saveNewExpTable(this.form);
            this.form.tier = null;
            this.form.level = null;
            this.form.exp_required = null;
            this.form.time_estimated_sec = null;
            this.dialogAddTemplate = false;
            this.$emit('success');
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.dialogLoading = false;
        }
    }
}
